// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import cn from 'classnames';

import styles from './radio_group.module.less';

export interface i_radio_item<T> {
    id: T;
    caption: React.ReactNode;
    item_cls?: string;
}
interface i_radio_group_props<T> {
    items: i_radio_item<T>[];
    selected: T;
    on_change: (v: T)=>void;
    cls?: string;
    fit?: boolean;
    cls_label?:string;
    cls_btn?:string;
}

export const Radio_group = <T extends string | number>({
    items, selected, on_change, cls, fit, cls_btn
}: i_radio_group_props<T>)=>{
    return <div className={cn(styles.radio_group, fit && styles.fit, cls)}>
      {items.map(item=>
        <button key={item.id} onClick={()=>on_change(item.id)}
          className={cn(styles.radio_item, cls_btn, item.item_cls,
            item.id==selected && styles.selected)}
        >{item.caption}</button>
      )}
    </div>;
};

export const Radio_group_general = <T extends string | number>({
    selected,
    items,
    on_change,
    cls,
    cls_label,
}: i_radio_group_props<T>)=><div
  className={cn(styles.radio_group_general, cls)}>
    {items.map(({id, caption})=>
      <label key={id} className={styles.radio_option}>
        <input
          type="radio"
          checked={selected === id}
          onChange={()=>on_change(id)}
        />
        <p className={cn(cls_label)}>{caption}</p>
      </label>
    )}
    </div>;
